<template>
  <div class="header">
    <div v-if="document" class="left-section">
      <router-link to="/profile/documents" class="return-label">
        <i class="fa fa-angle-left" aria-hidden="true"></i>
        Regresar
      </router-link>
      <div class="content-title">
        <h2 class="title">{{ document.name }}</h2>
        <span
          class="status"
          :class="{'is-status-success': document.enabled}"
        >
        {{ document.enabled ? 'Activa' : 'Borrador' }}
        </span>
      </div>
    </div>
    <div class="actions">
      <button class="button is-guide" @click="openGuideModal">
        <img src="@/assets/download.png" alt="download" class="button-icon" />
        Guía de llenado
      </button>

      <div v-if="!edit && document && document.type">
        <button class="button is-edit" @click="modeEdit">Editar</button>
      </div>

      <div v-if="edit && document && document.template" class="edit-actions">
        <button class="button is-cancel" :disabled="isLoading" @click="modeEdit">Cancelar</button>
        <button
          class="button is-save"
          :class="{'is-loading': isLoading}"
          :disabled="isLoading"
          @click="update"
        >
          Guardar
        </button>
      </div>
    </div>
    <modal-download-guide
      v-if="showGuideModal"
      :active="showGuideModal"
      :close="closeGuideModal"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import mixins from '@/mixins/formats'

export default {
  name: 'DocumentosContractuales',
  mixins: [mixins],
  components: {
    ModalDownloadGuide: () => import('@/components/ContractualDocuments/ModalDownloadGuide')
  },
  props: {
    edit: {
      type: Boolean,
      default: false
    },
    modeEdit: {
      type: Function,
      default: () => {}
    },
    document: {
      type: Object || null
    },
    updateHtml: {
      type: Function,
      default: () => {}
    },
    reload: {
      type: Function,
      default: () => {}
    }
  },
  data () {
    return {
      isLoading: false,
      showGuideModal: false
    }
  },
  computed: {
    ...mapState({
      systemConfiguration: state => state.configuration,
      profile: state => state.financialCompany.financialCompany
    })
  },
  async mounted () {
  },
  methods: {
    ...mapActions([]),
    async update () {
      this.isLoading = true
      const response = await this.updateHtml()
      if (response.success) {
        await this.reload()
        this.modeEdit()
      }
      this.isLoading = false
    },
    openGuideModal () {
      this.showGuideModal = true
    },
    closeGuideModal () {
      this.showGuideModal = false
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  background: #FFF;
  border-bottom: 1px solid #f6f6f6;
  padding: 1rem;
  height: 80px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  position: relative;

  .left-section {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    gap: 6px;
  }

  .content-title {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .title {
    font-size: 20px;
    font-weight: 600;
    margin: 0;
    color: #333;
  }

  .status {
    font-size: 13px;
    color: #8d8d8d;
    position: relative;
    padding-left: 1rem;
    margin-left: 0.5rem;
  }

  .is-status-success {
    color: #4ecdc4;
  }

  .status::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0.2rem;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #e5e5e5;
  }

  .is-status-success::before {
    background: #4ecdc4;
  }

  .return-label {
    font-size: 12px;
    color: #4f73ff !important;
    cursor: pointer;
    text-decoration: none;
    display: flex;
    align-items: center;
    gap: 4px;

    i {
      font-size: 10px;
    }

    &:hover {
      color: #3d5bff !important;
    }
  }
}

.actions {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-top: 8px;

  .button {
    padding: 0.5rem 1rem;
    font-size: 14px;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    border-radius: 6px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s ease;
    border: none;
  }

  .is-guide {
    background: white;
    color: #4f73ff;
    border: 1px solid #4f73ff;

    .button-icon {
      width: 16px;
      height: 16px;
      filter: brightness(0) saturate(100%) invert(42%) sepia(92%) saturate(1352%) hue-rotate(219deg) brightness(103%) contrast(104%);
    }

    &:hover {
      background: #f8f9ff;
    }
  }

  .is-edit {
    background: #4f73ff;
    color: white;

    &:hover {
      background: #3d5bff;
    }
  }

  .edit-actions {
    display: flex;
    gap: 0.75rem;
  }

  .is-cancel {
    background: #ff6b6b;
    color: white;

    &:hover {
      background: #ff5252;
    }

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }

  .is-save {
    background: #4ecdc4;
    color: white;

    &:hover {
      background: #45b7aa;
    }

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }

    &.is-loading {
      opacity: 0.7;
    }
  }
}
</style>
